module.exports = __webpack_public_path__ + "static/media/bonus.3ef7a8f2.png";